import { render, staticRenderFns } from "./equity.vue?vue&type=template&id=48349d2a&scoped=true&"
import script from "./equity.vue?vue&type=script&lang=js&"
export * from "./equity.vue?vue&type=script&lang=js&"
import style0 from "./equity.vue?vue&type=style&index=0&id=48349d2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48349d2a",
  null
  
)

export default component.exports